export default __webpack_public_path__ + "static/media/ic_nurses.d4ac4368.svg";